module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-bg login-bg",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6"
  }, [_c('div', {
    staticClass: "login"
  }, [_c(_vm.passwordComponent, {
    tag: "component"
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4c755ca0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = 994
// module chunks = 0